export class DeleteFileExpense {
    id: number;
    fileId: number;
    constructor (id,fileId) {
        this.id = id;
        this.fileId = fileId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/info/class/delete-file-expense.ts